// Next Diamonds — search overlay quick links, loaded on demand.
//
// The shapes row carries eleven inline SVG icons (about 60 KB of markup).
// Rather than ship that in every page's HTML, the block is fetched once, the
// first time a visitor reaches for search (hover, touch, focus or click on the
// search control), and placed into the empty slot in the overlay.
(function () {
  'use strict';

  var slot = document.querySelector('[data-nd-search-quick]');
  if (!slot) return;

  var url = slot.getAttribute('data-url');
  var state = 'idle'; // idle | loading | done

  function load() {
    if (state !== 'idle' || !url) return;
    state = 'loading';
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        // Parse off-document and move the node across; no innerHTML on the page.
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var block = doc.querySelector('.nd-search-quick');
        state = 'done'; // an empty section (no menu) is a valid final answer
        if (block) slot.appendChild(document.importNode(block, true));
      })
      .catch(function () {
        state = 'idle'; // network hiccup: try again on the next intent
      });
  }

  function isSearchControl(target) {
    return !!(target && target.closest && target.closest('.show-search-link, a[href$="/search"]'));
  }

  ['pointerover', 'touchstart', 'focusin', 'click'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (isSearchControl(e.target)) load();
    }, { passive: true, capture: true });
  });

  // Safety net: the overlay can be opened by other code paths.
  new MutationObserver(function () {
    if (document.body.classList.contains('show-search')) load();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
